<div class="container bred_border">
  <div class="row page_mar_t ">
    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item "><a routerLink="/Home">Home</a></li>
          <li class="breadcrumb-item"><a style="width: auto;cursor:pointer">Products</a></li>
          <li class="breadcrumb-item bread_active" aria-current="page"> {{CategoryName}}</li>
        </ol>
      </nav>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 icons" style="padding-right: 0;">
          <a href="tel:7569041276">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M72.5625,71.21875c0,8.33125 0,47.03125 0,47.03125h47.03125c25.93437,0 47.03125,-21.09687 47.03125,-47.03125c0,-25.93437 -21.09688,-47.03125 -47.03125,-47.03125c-25.93438,0 -47.03125,21.09688 -47.03125,47.03125z" fill="#ffffff"></path><path d="M10.48125,40.71563v0c-5.9125,29.5625 -5.9125,60.06563 0,89.62813v0v0c3.35938,16.93125 18.14063,29.15938 35.475,29.15938v0v0v0v0c4.43437,0 7.79375,-3.89688 7.25625,-8.33125l-3.225,-24.05313c-0.94063,-6.58438 -6.58438,-11.55625 -13.16875,-11.55625v0c-6.71875,0 -11.69062,1.74688 -11.69062,1.74688v-31.7125v-31.7125c0,0 5.10625,1.74688 11.69063,1.74688v0c6.71875,0 12.3625,-4.97188 13.16875,-11.55625l3.225,-24.05312c0.5375,-4.43438 -2.82187,-8.33125 -7.25625,-8.33125v0c-17.33437,0 -32.11562,12.09375 -35.475,29.025z" fill="#ffffff"></path><path d="M36.81875,59.52813c8.6,0 15.99062,-6.45 17.2,-15.05l3.225,-24.05312c0.40313,-3.225 -0.5375,-6.45 -2.6875,-9.00312c-2.15,-2.55312 -5.24062,-3.89687 -8.6,-3.89687c-19.21563,0.13438 -35.74375,13.70625 -39.50625,32.51875c-6.04687,30.23438 -6.04687,60.87187 0,91.10625c3.7625,18.8125 20.29062,32.38437 39.37187,32.38437c2.28438,0 4.03125,-1.74687 4.03125,-4.03125c0,-2.28438 -1.74687,-4.03125 -4.03125,-4.03125c-15.31875,0 -28.4875,-10.88437 -31.44375,-25.93437c-5.77813,-29.15938 -5.77813,-58.85625 0,-88.01562c2.95625,-15.05 16.25938,-25.93437 31.44375,-25.93437c1.34375,0 2.15,0.67188 2.41875,1.075c0.40312,0.40313 0.94062,1.34375 0.80625,2.55313l-3.225,24.05312c-0.67187,4.56875 -4.56875,8.0625 -9.27187,8.0625c-5.9125,0 -10.48125,-1.47812 -10.48125,-1.47812c-1.20937,-0.40312 -2.55312,-0.13438 -3.62812,0.5375c-1.075,0.80625 -1.6125,2.01563 -1.6125,3.225v66.1125c0,1.6125 0.94063,2.95625 2.28438,3.62813c1.34375,0.67188 3.09062,0.40312 4.3,-0.5375c0,0 4.3,-3.49375 9.1375,-3.49375c4.70313,0 8.6,3.49375 9.27187,8.0625l1.74688,12.63125c0.26875,2.01563 2.01563,3.49375 4.03125,3.49375c0.13437,0 0.40312,0 0.5375,0c2.15,-0.26875 3.7625,-2.28437 3.49375,-4.56875l-1.74688,-12.63125c-1.075,-8.33125 -8.46563,-14.78125 -17.06562,-14.78125c-2.82188,0 -5.50938,0.67188 -7.65938,1.47812v-54.01875c2.01563,0.26875 4.70312,0.5375 7.65938,0.5375z" fill="#444b54"></path><path d="M119.59375,122.28125h-47.03125c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125v-47.03125c0,-28.21875 22.84375,-51.0625 51.0625,-51.0625c28.21875,0 51.0625,22.84375 51.0625,51.0625c0,28.21875 -22.84375,51.0625 -51.0625,51.0625zM76.59375,114.21875h43c23.65,0 43,-19.35 43,-43c0,-23.65 -19.35,-43 -43,-43c-23.65,0 -43,19.35 -43,43z" fill="#71c2ff"></path><path d="M133.03125,91.375h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M133.03125,71.21875h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M63.69375,163.53438c-2.28438,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28438 1.74687,-4.03125 4.03125,-4.03125c5.10625,0 9.80937,-2.01562 13.4375,-5.50938c0.80625,-0.80625 1.88125,-1.20937 2.95625,-1.20937c1.075,0 2.15,0.5375 2.95625,1.34375c2.41875,2.6875 5.77813,4.3 9.40625,4.3c3.62812,0.13438 6.9875,-1.20937 9.675,-3.89687l0.67188,-0.67187c1.6125,-1.6125 4.16562,-1.6125 5.64375,0l1.34375,1.34375c2.41875,2.41875 5.77812,3.89687 9.27188,3.89687c3.49375,0 6.85312,-1.34375 9.27187,-3.89687l1.34375,-1.34375c1.6125,-1.6125 4.16563,-1.6125 5.64375,0l6.71875,6.71875c1.6125,1.6125 1.6125,4.16563 0,5.64375c-1.6125,1.6125 -4.16562,1.6125 -5.64375,0l-3.89687,-3.89688c-3.7625,3.09063 -8.46563,4.70313 -13.30313,4.70313c-4.97188,0 -9.675,-1.74687 -13.57187,-4.8375c-3.7625,2.82187 -8.33125,4.3 -13.30313,4.16562c-4.56875,-0.13437 -8.73437,-1.6125 -12.22813,-4.3c-4.97188,3.62812 -10.48125,5.50938 -16.39375,5.50938z" fill="#444b54"></path></g></g></svg>
          </a>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 icons">
          <a href=" https://api.whatsapp.com/send?phone=917569041276&amp;text=Chat with our Experts." class="float" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g id="Layer_1"><path d="M86,165.28125c43.67188,0 79.28125,-35.60937 79.28125,-79.28125c0,-21.23125 -8.19688,-41.11875 -23.24687,-56.03437c-14.91563,-15.05 -34.80313,-23.24687 -56.03438,-23.24687c-43.67187,0 -79.28125,35.475 -79.28125,79.28125c0,13.975 3.62813,27.54688 10.61563,39.64063l-7.525,27.68125c-1.6125,5.9125 3.7625,11.42188 9.80938,9.80937l28.62188,-7.525c11.42187,6.31563 24.45625,9.675 37.75937,9.675z" fill="#ffffff"></path><path d="M86,149.15625c-10.48125,0 -20.9625,-2.6875 -30.23437,-7.65938c-2.41875,-1.34375 -5.10625,-2.01562 -7.65938,-2.01562c-1.34375,0 -2.6875,0.13438 -4.03125,0.5375l-15.05,3.89687l3.89687,-14.10937c1.075,-4.16562 0.5375,-8.6 -1.6125,-12.3625c-5.64375,-9.54063 -8.46562,-20.425 -8.46562,-31.44375c0,-34.9375 28.35313,-63.15625 63.15625,-63.15625c16.93125,0 32.7875,6.58437 44.74687,18.54375c11.825,11.825 18.40938,27.68125 18.40938,44.6125c0,34.80313 -28.35312,63.15625 -63.15625,63.15625z" fill="#5bf979"></path><path d="M144.99063,27.14375c-15.72187,-15.72187 -36.68438,-24.45625 -58.99062,-24.45625c-45.95625,0 -83.3125,37.35625 -83.3125,83.3125c0,14.10938 3.49375,27.95 10.34687,40.17813l-7.12187,26.06875c-1.20938,4.16562 0,8.46562 3.09062,11.55625c3.09063,3.09063 7.39063,4.3 11.55625,3.225l27.14375,-7.12187c11.825,6.18125 24.99375,9.40625 38.43125,9.40625c45.95625,0 83.3125,-37.35625 83.3125,-83.3125c-0.13438,-22.17188 -8.73437,-43.13438 -24.45625,-58.85625zM86,161.25c-12.49688,0 -24.99375,-3.225 -36.0125,-9.1375c-0.5375,-0.26875 -1.20938,-0.5375 -1.88125,-0.5375c-0.40312,0 -0.67187,0 -1.075,0.13438l-28.62187,7.525c-2.01562,0.5375 -3.35937,-0.5375 -3.89687,-1.075c-0.5375,-0.5375 -1.6125,-1.88125 -1.075,-3.89687l7.525,-27.68125c0.26875,-1.075 0.13438,-2.15 -0.40312,-3.09062c-6.45,-11.2875 -9.80938,-24.32187 -9.80938,-37.49062c0,-41.52187 33.72813,-75.25 75.25,-75.25c20.15625,0 39.10312,7.79375 53.2125,22.0375c14.24375,14.24375 22.17188,33.19063 22.0375,53.2125c0,41.52188 -33.72812,75.25 -75.25,75.25z" fill="#444b54"></path><g fill="#006475"><path d="M124.83438,114.35313c-1.6125,4.56875 -9.675,9.1375 -13.4375,9.40625c-3.62813,0.26875 -6.9875,1.6125 -23.78438,-4.97187c-20.15625,-7.92813 -32.92187,-28.62188 -33.8625,-29.96563c-0.94063,-1.34375 -8.0625,-10.75 -8.0625,-20.55937c0,-9.80938 5.10625,-14.5125 6.9875,-16.52813c1.88125,-2.01562 3.89687,-2.41875 5.24062,-2.41875c1.34375,0 2.6875,0 3.7625,0c1.47812,0 2.95625,0.13437 4.43437,3.35938c1.74687,3.89687 5.64375,13.70625 6.04688,14.64688c0.5375,0.94062 0.80625,2.15 0.13438,3.49375c-0.67187,1.34375 -0.94063,2.15 -2.01562,3.35938c-0.94063,1.20938 -2.15,2.55313 -2.95625,3.49375c-0.94062,0.94063 -2.01562,2.01563 -0.80625,4.03125c1.20938,2.01563 5.10625,8.46563 11.01875,13.70625c7.525,6.71875 13.975,8.86875 15.99063,9.80938c2.01563,0.94062 3.09063,0.80625 4.3,-0.5375c1.20937,-1.34375 4.97187,-5.77813 6.31562,-7.79375c1.34375,-2.01562 2.6875,-1.6125 4.43438,-0.94062c1.88125,0.67188 11.55625,5.50937 13.57187,6.45c2.01563,0.94063 3.35938,1.47812 3.7625,2.28438c0.5375,1.075 0.5375,4.97187 -1.075,9.675z"></path></g></g></g></svg>
          </a>

        </div>
      </div>

    </div>
  </div>
</div>

<div class="container margin_t_0_5">
  <div class="row">
    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 fixed">
      <ul>
        <li class="tab_li sp" *ngFor="let item of categories" [class.active]="categoryId ==item.CategoryID" href="#p1" (click)="FilterList(item.CategoryID)">{{item.CategoryName}}</li>
      </ul>
    </div>
    <!--<div class="col-lg-10 col-md-7 col-sm-12 col-xs-12 product_list_b">
      <div class="row">
        <div class="col-lg-4"><img width="100%" src="https://res.cloudinary.com/tbmg/c_scale,w_400,f_auto,q_auto/v1606815891/mdb/articles/2020/features/MDB-1220-p14_fig1.jpg" alt="Designing High Reliability into Life-Saving Cardiac Care Instruments -  Medical Design Briefs" /></div>
        <div class="col-lg-8">
          <h3>
            Medical Instruments
          </h3>
          <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </h5>
          <br />
          <button type="button" class="btn btn-success">Add To Enquiry</button>
          <br /><br />
          <h4>Overview</h4>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem</p>
          <div class="row">
            <div class="col-lg-6">
              <div>
                <span><i class="fa fa-arrow-circle-o-down" style="color: green;" aria-hidden="true"></i></span>
                Download Brochure
              </div>
            </div>
            <div class="col-lg-6" style="    text-align: end;">
              <div>Share : <span><i class="fa fa-facebook-square" aria-hidden="true"></i></span> &nbsp;&nbsp;<span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span></div>
            </div>

          </div>
        </div>

      </div>

      </div>-->
    <div class="col-lg-6 col-md-7 col-sm-12 col-xs-12 product_list_b">
      <!--<div *ngFor="let item of ProductsList; let i=index">
        <div>
          <div class="row product_row" style="padding-right: 0;">
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              <ul style="display: inline-flex;">
                <li><div class="text_1">{{item.Catalog_No}}</div><div (click)="ProductInfo(item)" class="text">{{item.ChemicalName}}</div></li>

              </ul>

            </div>
            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12" style="padding-left: 0rem;">
              <div class="text">{{item.Pack1}}</div>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12" style="padding-right: 0;">
              <div style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" (click)="addToCart(item)" style="margin-left:1rem;cursor:pointer;" /></span></div>
            </div>

          </div>

        </div>

      </div>-->
      <div class="row chhead">
        <div class="col-lg-6">
          Product Name
        </div>
        <!--<div class="col-lg-2">
          Code
        </div>-->
        <div class="col-lg-5">
          Size
        </div>
        <div class="col-lg-1" style="padding:0">Cart</div>
      </div>
      <div class="" *ngFor="let item of ProductsList; let i=index">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" (click)="ProductInfo(item)" style="cursor:pointer">
            <div style="padding-bottom: 0.7rem;">{{item.Catalog_No}} | {{item.ChemicalName}} </div>
          </div>
          <div class="col-lg-6" (click)="ProductInfo(item)" style="cursor:pointer">
            
            <img style="width:100%" src="{{HomeURL+item.Image1}}" />
          </div>
          <!--<div class="col-lg-2">
            <div>{{item.Catalog_No}}</div>
          </div>-->
          <div class="col-lg-5">
            <!--<div (click)="ProductInfo(item)" style="cursor:pointer">
    {{item.ChemicalName}}
  </div>-->
            <!--<div style="background-color:#e4eff7">{{item.Pack1}} </div>-->
            <div>{{item.Pack1}} </div>
            <div>{{item.Pack2}} </div>
            <div>{{item.Pack3}} </div>
            <div>{{item.Pack4}} </div>
            <div>{{item.Pack5}} </div>
            <div>{{item.Pack6}} </div>
          </div>
          <div class="col-lg-1">
            <!--<div style="color:#fff">.</div>-->
            <div  (click)="addToCart(item,item.Pack1)" *ngIf="item.Pack1!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
            <div (click)="addToCart(item,item.Pack2)" *ngIf="item.Pack2!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
            <div (click)="addToCart(item,item.Pack3)" *ngIf="item.Pack3!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
            <div (click)="addToCart(item,item.Pack4)" *ngIf="item.Pack4!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
            <div (click)="addToCart(item,item.Pack5)" *ngIf="item.Pack5!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
            <div (click)="addToCart(item,item.Pack6)" *ngIf="item.Pack6!=''">
              <i class="fa fa-cart-plus" aria-hidden="true" style="cursor:pointer"></i>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div>
              <span *ngIf="item.ProductPdf != ''">
                <a href="{{HomeURL+item.ProductPdf}}" target="_blank">
                  <i class="fa fa-file-pdf-o" style="color: #ed1c24;" aria-hidden="true"></i>&nbsp; Download Brochure
                </a>
              </span>

            </div>
          </div>
          <div class="col-lg-6" style="    text-align: end;">

            <div class="row">
              <b style="margin-left:130px;">Share :</b>
              <div class="col-lg-1">
                <a (click)="sendWhatsapp(item)" style="cursor:pointer" class="float" target="_blank">
                  <span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span>
                </a>
                <!--<a href=" https://api.whatsapp.com/send?phone=919030152953&amp;text={{HomeURL}}" class="float" target="_blank">
                  <span> <i class="fa fa-whatsapp" aria-hidden="true"></i></span>
                 </a>-->
              </div>
              <div class="col-lg-1">
                <!--<a class="fb-ic" (click)="sendFacebook(item)" target="_blank">
                  <span><i class="fa fa-facebook-square" aria-hidden="true"></i></span>
                </a>-->
                <a class="fb-ic" href="https://www.facebook.com/klsindia/" target="_blank">
                  <span><i class="fa fa-facebook-square" aria-hidden="true"></i></span>
                </a>
              </div>
            </div>
          </div>

        </div>
        <hr />
      </div>



      <!--<div class="row product_row" style="padding-right: 0;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0">

          <p-accordion [multiple]="false">
            <div *ngFor="let item of ProductsList; let i=index">
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div class="row">
                    <div class="col-lg-2" style="width: 12rem;">
                      <b style="font-size: 22px;color: #007cb5;">  {{item.Catalog_No}}</b>
                    </div>
                    <div class="col-lg-10" style="color: #f0373e;">
                      {{item.ChemicalName}}
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-lg-5">
                        <div>
                          <img style="width:110%; margin-top: 12px;" src="../../../assets/img/website/pngtree-chemical-formula-image_1297650.jpg" />
                        </div>
                      </div>
                      <div class="col-lg-1">
                      </div>
                      <div class="col-lg-4">
                        <div>{{item.Pack1}} </div>
                        <div>{{item.Pack2}} </div>
                        <div>{{item.Pack3}} </div>
                        <div>{{item.Pack4}} </div>
                        <div>{{item.Pack5}} </div>
                        <div>{{item.Pack6}} </div>
                      </div>
                      <div class="col-lg-2">
                        <div (click)="addToCart(item,item.Pack1)" *ngIf="item.Pack1!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                        <div (click)="addToCart(item,item.Pack2)" *ngIf="item.Pack2!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                        <div (click)="addToCart(item,item.Pack3)" *ngIf="item.Pack3!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                        <div (click)="addToCart(item,item.Pack4)" *ngIf="item.Pack4!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                        <div (click)="addToCart(item,item.Pack5)" *ngIf="item.Pack5!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                        <div (click)="addToCart(item,item.Pack6)" *ngIf="item.Pack6!=''" style="float: right;width: 100%;text-align: right;margin-right: 1rem;"> <span><img src="https://img.icons8.com/fluent-systems-filled/25/000000/add-basket.png" style="margin-left:1rem;cursor:pointer;" /></span></div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </div>
          </p-accordion>
        </div>
      </div>-->
      <!--<div class="row product_row" style="padding-right: 0;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="columnOne" id="accordion" role="tablist" aria-multiselectable="true">
            <div *ngFor="let data of ProductsList; let i=index" style="border-bottom: 1px solid rgba(0, 0, 0, 0.14);">
              <div class="panel-heading" role="tab" [id]="'heading'+data.P_ID">
                <a role="button" data-toggle="collapse" data-parent="#accordion" [href]="'#collapse'+data.P_ID" aria-expanded="true" [attr.aria-controls]="'collapse'+data.P_ID">
                  <table>
                    <tr>
                      <td style="width:50%">{{data.Catalog_No}}</td>
                      <td style="width:100%">{{data.ChemicalName}}</td>
                    </tr>
                  </table>
                </a>
              </div>
              <div [id]="'collapse'+data.P_ID" class="panel-collapse collapse" role="tabpanel" [attr.aria-labelledby]="'heading'+data.P_ID">
                <div class="panel-body">
                  <table>
                    <tr>
                      <th>Pack</th>
                      <th>Add to cart</th>
                    </tr>
                    <tr><td>{{data.Pack1}}</td></tr>
                    <tr><td>{{data.Pack2}}</td></tr>
                    <tr><td>{{data.Pack3}}</td></tr>
                    <tr><td>{{data.Pack4}}</td></tr>
                    <tr><td>{{data.Pack5}}</td></tr>
                    <tr><td>{{data.Pack6}}</td></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!--<div>
        <div>
          <table class="table table-responsive table-hover">
            <tbody *ngFor="let item of ProductsList; let i=index">
              <tr data-toggle="collapse" id="'table1'+item.P_ID" data-target=".table1+item.P_ID">
                <td>{{item.Catalog_No}}</td>
                <td>D{{item.ChemicalName}}avid</td>
              </tr>
              <tr class="collapse table1+item.P_ID">
                <td colspan="999">
                  <div>
                    <table class="table table-striped">
                      d>
                      <thead>
                        <tr>
                          <th>Column 1</th>
                          <th>Column 2</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Column 1</td>
                          <td>Column 2</td>
                        </tr>
                        <tr>
                          <td>Column 1</td>
                          <td>Column 2</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>-->

    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 enqury_box">
      <div class="enquiry_heading">
        CART FOR ENQUIRY
      </div>
      <div>
        <table style="width:100%;">
          <tr class="table_header" style="border-bottom: 1px dashed #831f41;">

            <td style="width:5%;">#</td>
            <td style="width:60%;">Product Details</td>

            <td style="width:15%;">Pack</td>
            <!--<td style="width:20%;">Code</td>-->
            <td style="width:10%;">Qty</td>
            <td style="width:10%;"></td>
          </tr>

          <br />

          <tr class="product_cart" *ngFor="let item of cartData; let i=index" style="height:50px;">
            <td valign="top" style="width:5%;"> <div style="margin-top: -0.4rem;font-weight: bold;"> {{i+1}} </div></td>
            <td style="width:60%;line-height: 1.5;padding-bottom:0.5rem;">

              <strong> {{item.Catalog_No}} </strong><br />
              {{item.ChemicalName}}
            </td>

            <!--<td style="width:20%;">{{item.ChemicalName}}</td>-->
            yl
            <td style="width:15%;">{{item.Pack}}</td>
            <td style="width:10%;"><input type="text" class="form-control_cart" id="usr" [value]="item.Qty"></td>
            <td style="width:10%;">
              <!--<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="25" height="25"
              viewBox="0 0 48 48"
              (click)="removeFromCart(i)"
              style=" fill:#ff0000;cursor:pointer;margin-left:1rem;"><path d="M 24 6.0097656 C 22.756471 6.0097656 21.514322 6.4798191 20.574219 7.4199219 L 9.9921875 18 L 6.5019531 18 C 5.4549531 18 4.4716875 18.462531 3.8046875 19.269531 C 3.1376875 20.076531 2.8655 21.127297 3.0625 22.154297 L 5.8359375 36.716797 C 6.4189375 39.777797 9.1056563 42 12.222656 42 L 24.044922 42 C 23.451922 41.074 22.971953 40.067 22.626953 39 L 12.222656 39 C 10.543656 39 9.0962031 37.803297 8.7832031 36.154297 L 6.0097656 21.59375 C 5.9717656 21.39375 6.0602344 21.248641 6.1152344 21.181641 C 6.1712344 21.112641 6.2969531 21 6.5019531 21 L 10.34375 21 A 1.50015 1.50015 0 0 0 10.833984 21 L 37.164062 21 A 1.50015 1.50015 0 0 0 37.65625 21 L 41.498047 21 C 41.703047 21 41.828766 21.112641 41.884766 21.181641 C 41.940766 21.248641 42.029234 21.39275 41.990234 21.59375 L 41.572266 23.78125 C 42.547266 24.35425 43.441422 25.051609 44.232422 25.849609 L 44.9375 22.154297 C 45.1335 21.127297 44.862313 20.076531 44.195312 19.269531 C 43.528312 18.462531 42.545047 18 41.498047 18 L 38.007812 18 L 27.427734 7.4199219 C 26.487632 6.4798191 25.243529 6.0097656 24 6.0097656 z M 24 8.9902344 C 24.469383 8.9902344 24.939743 9.1741184 25.306641 9.5410156 L 33.765625 18 L 14.234375 18 L 22.695312 9.5410156 C 23.06221 9.1741184 23.530617 8.9902344 24 8.9902344 z M 35 24 C 28.925 24 24 28.925 24 35 C 24 41.075 28.925 46 35 46 C 41.075 46 46 41.075 46 35 C 46 28.925 41.075 24 35 24 z M 13.519531 24.978516 A 1.50015 1.50015 0 0 0 12.003906 26.607422 L 12.503906 33.607422 A 1.50015 1.50015 0 1 0 15.496094 33.392578 L 14.996094 26.392578 A 1.50015 1.50015 0 0 0 13.519531 24.978516 z M 20.476562 24.978516 A 1.50015 1.50015 0 0 0 19 26.5 L 19 33.5 A 1.50015 1.50015 0 1 0 22 33.5 L 22 26.5 A 1.50015 1.50015 0 0 0 20.476562 24.978516 z M 28 34 L 42 34 C 42.552 34 43 34.448 43 35 C 43 35.552 42.552 36 42 36 L 28 36 C 27.448 36 27 35.552 27 35 C 27 34.448 27.448 34 28 34 z"></path></svg>-->
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   width="25" height="25"
                   viewBox="0 0 172 172"
                   (click)="removeFromCart(i)"
                   style=" fill:#000000;margin-left: 0.5rem;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M121.83333,39.41667l-21.5,-21.5h-28.66667l-21.5,21.5h-10.75v100.33333c0,7.88333 6.45,14.33333 14.33333,14.33333h64.5c7.88333,0 14.33333,-6.45 14.33333,-14.33333v-100.33333z" fill="#ff3d00"></path><path d="M39.41667,25.08333h93.16667c3.94167,0 7.16667,3.225 7.16667,7.16667v7.16667h-107.5v-7.16667c0,-3.94167 3.225,-7.16667 7.16667,-7.16667z" fill="#ff6e40"></path><path d="M59.4334,113.18215l43.00036,-43.00186l10.13537,10.13502l-43.00036,43.00186z" fill="#fafafa"></path><path d="M59.43283,80.31878l10.13502,-10.13537l43.00186,43.00036l-10.13502,10.13537z" fill="#fafafa"></path></g></g></svg>
            </td>
          </tr>




        </table>

        <br />
        <form [formGroup]="form" (ngSubmit)="sendEnquiry(form.value)">
          <div><input type="text" class="form-control_t_b" placeholder="Person Name" [formControl]="personName"></div>
          <div><input type="text" class="form-control_t_b" placeholder="Contact Number" [formControl]="contactNumber"></div>
          <div><input type="text" class="form-control_t_b" placeholder="Email" [formControl]="email"></div>
          <!--<div><input type="text" class="form-control_t_b" placeholder="Comments" [formControl]="comments"></div>-->
          <div>
            <textarea style="height: 100px;
    padding-top: 0.7rem;" rows="4" cols="50" class="form-control_t_b" placeholder="Comments" [formControl]="comments">
 
  </textarea>
          </div>

          <button type="submit" [disabled]="form.invalid" class="btn enquiry_button button_p">SUBMIT</button>
        </form>

      </div>
    </div>
  </div>
</div>

<style>
  /*a:hover {
    background-color: yellow;
  }*/
</style>
